<template>
  <div class="row" ref="proxy">
    <div class="col-12">
      <c-card title="참석자 서명보기" class="cardClassDetailInfo" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="row">
            <div class="col-xs-12 col-sm-12">
              <VueSignaturePad width="200px" height="200px" ref="signaturePad" />
            </div>
          </div>
        </template>
      </c-card>
    </div>
  </div>
</template>
<script>
import VueSignaturePad from 'vue-signature-pad';
import Vue from 'vue';
let signaturePad = null;
Vue.use(VueSignaturePad)
export default {
  name: 'signature-pop',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          attendeeSign: '',
        }
      },
    },
    data: {
      type: Object,
      default(){
        return {
          tbmCompleteFlag: '',
        }
      },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      if (!this.$refs.signaturePad) {return;}
      this.windowWidth = (document.documentElement.clientWidth - 45) + 'px';
      signaturePad = this.$refs.signaturePad
      signaturePad.lockSignaturePad()
      if (this.popupParam.attendeeSign) {
        signaturePad.fromDataURL(this.popupParam.attendeeSign);
      }
    },
    acceptSignature() {
      let data = ''
      if (signaturePad.saveSignature()) {data = signaturePad.saveSignature().data;}
      this.$emit('attendeeSignCallback', data, this.rowIndex);
    },
    eraseSignature() {
      signaturePad.clearSignature();
      this.popupParam.attendeeSign = '';
    },
    reset() {
      Object.assign(this.$data.info, this.$options.data().info);
    },
  }
};
</script>